<div class="tabs-wrapper" [ngClass]="{ 'mt-m14': quoteComparisonDetailType !== QuoteComparisonDetailType.SpecialConditions }">
  <ion-grid class="limit-width-on-desktop-float p-20">
    <ion-row>
      <div (click)="slidePrevious()">
        <ion-icon
          class="left-arrow icon-fill-dark"
          src="assets/icon/genetic-icons/chevron-left.svg"
          [ngClass]="{ disabled: disableLeft }"
          (click)="slidePrevious()"
        ></ion-icon>
      </div>
      <swiper-container style="width: 100%; padding: 0 12px;" #slides slides-per-view="3" [loop]="false" autoplay="false" (swiperslidechange)="slideDidChange()">
        <swiper-slide *ngFor="let quoteComparisonAssetTab of quoteComparisonAssetTabs; let i = index">
          <div class="tab" [ngClass]="{ 'active-tab': quoteComparisonAssetTab.active }" (click)="tabSelected(quoteComparisonAssetTab)">
            <p>{{ quoteComparisonAssetTab.name }}</p>
          </div>
        </swiper-slide>
      </swiper-container>
      <div (click)="slideNext()">
        <ion-icon class="right-arrow icon-fill-dark" src="assets/icon/genetic-icons/chevron-right.svg" [ngClass]="{ disabled: disableRight }"></ion-icon>
      </div>
    </ion-row>
  </ion-grid>
</div>
